$(document).ready(() => {
    $(".custom-slider-btn").on("click", (e) => {
      var el = e.currentTarget;
      var blockId = $(el).attr("data-id");
      var sectionId = $(el).attr("data-section-id");
      [...$(".custom-slider-btn-" + sectionId)].map((element) => {
        $(element).removeClass("custom-slider-btn-active");
      });
      $(el).addClass("custom-slider-btn-active");
      $(".slider-mobile-gutter-" + sectionId).hide();
      $(".slider-mobile-gutter-" + sectionId + "-" + blockId).show();
    });
  });
  